import { ErrorMessage } from 'formik';
import React from 'react';
import TagsInput from 'react-tagsinput';
import { formErrorMessage } from '../formikComponents/FormErrorMessage';
import './_react-taginput.scss';
import styled from 'styled-components';

const TagInput = ({
  name,
  value,
  onChange,
  validationRegex,
  placeholder,
  errors,
  tagsClass,
  className,
  onlyUnique,
  disabled = false,
  wrapperClass,
  inputClass,
  ...props
}) => (
  <TagInputWrapper className={wrapperClass} disabled={disabled} errors={errors && errors[name]}>
    <TagsInput
      {...props}
      onlyUnique={onlyUnique}
      validationRegex={validationRegex && validationRegex}
      name="keywords"
      value={value}
      onChange={onChange}
      tagProps={{ className: tagsClass && `${tagsClass}` }}
      inputProps={{
        placeholder: `${placeholder}`,
        className: inputClass && `${inputClass}`,
        disabled: disabled,
      }}
    />
    <ErrorMessage name={name} render={formErrorMessage} />
  </TagInputWrapper>
);


const TagInputWrapper = styled.div`
  .react-tagsinput {
    border: 0;
   
`;
export default TagInput;
